export enum AlarmNotificationTabs {
    Locations = 0,
    Alarm = 1, 
    NotificationTree = 2,
    Validation = 3,
    ConfirmConfigurations = 4
}
